module.exports = __webpack_public_path__ + "static/media/close-overlay.be5883b5.svg";